import React from "react";

const PoliciesExperts = () => {
	return (
		<div>
			<h2>Acuerdos y Terminos de condiciones de uso</h2>
			<p>
				¡Bienvenidos a Needex!<br />
				<br />Needex es una aplicación que es enfocado en ser un instrumento
				digital que provee las referencias de profesionales en áreas técnicas,
				para la asistencia de reparaciones, servicios o cualquier otra necesidad
				para los usuarios y usuarias que lleguen a usar Needex. <br />La función
				principal de Needex es disponer referencias en el sector laboral
				técnico, en principio, para personas que necesiten la asistencia de los
				siguientes servicios como: refrigeración, electricidad, plomería,
				mecánica, construcción, carpintería, soldadura, pintura, lavadoras,
				jardinería y fumigación.<br />Estos mismos técnicos a los que nos
				referimos como profesionales ya sean licenciados o tengan otro tipo de
				formación. Las personas que lleguen a usar Needex siempre tendrán la
				libertad de usar o no usar nuestra aplicación, bajo las directrices que
				les demostramos al público de manera general. Formamos parte del sector
				informal pero privado, por lo que generamos recursos económicos a través
				de pagos por adelantado que se tienen por definidas como comisiones por
				los trabajos que baya a realizar el experto y vaya a pagar el usuario o
				usuaria final. Descarga la aplicación Needex de forma sencilla y úsala.
				Si tú eres una persona con ganas de trabajar tienes la opción de
				descargar y usar Needex para poder ganar dinero con nosotros. Podrás
				escoger los trabajos más cercanos y los que mejor te convengan a ti.
				Podrás cobrar la tarifa que mejor consideres a lo que vale tu trabajo.
				Needex es una aplicación que sirve como instrumento digital que proveerá
				al público en general tus servicios como experto a cambio de una
				comisión, dentro de la aplicación que será expresaba en créditos, que
				podrás comprar dentro de esta misma. Esto para facilitar el proceso
				haciéndolo mucho más interactivo y fácil de usar.<br />
				<br />Needex brinda sus usuarios la libertad de escoger al experto del
				trabajo que consideren mejor y más cercano.<br />Podrás elegir al
				experto que mas se acomode a la tarifa que quieras pagar.<br />En
				nuestra aplicación podrás puntuar el servicio de cada experto de manera
				sencilla y práctica.<br />Regístrate de manera sencilla y rápida.<br />Siempre
				tendrás la libertad de usar y no usar nuestra aplicación.<br />Nosotros
				verificamos la identidad de los profesionales.<br />Puedes contactar a
				nuestro soporte en cualquier momentos, los metodos de contacto estan en
				nuestra aplicación por si necesitas asistencia de cualquier tipo.<br />
			</p>
			<h2>Politicas de Privacidad!</h2>
			<p>
				Nuestras políticas de privacidad están orientadas a cumplir con los
				requerimientos que nos exige respectivamente la plataforma en la que se
				ha visto lanzada la aplicación Needex, Google. La aplicación Needex esta
				comprometida con la privacidad, seguridad de los usuarios, usuarias y
				expertos, respectivamente, ya que se compromete a solo usar la
				información, que se exija bajo la simpleza de mostrarla los paneles
				interactivos de la aplicación. Needex protege la información brindada,
				no la compartirá con terceros, como anuncios o agentes en la red, o
				plataformas denominadas como redes sociales, páginas web y muchas otras
				más. Nosotros cuando le pidamos llenar los datos con su información
				personal indiferentemente, si es un usuario o un experto se manejarán
				únicamente con la finalidad que esta dispuesta en la aplicación. Que es
				solo para conocer la ubicación del experto y del usuario final,
				incluyendo, pero no limitando el monitoreo personal de ambas partes.
				Esto únicamente para que el proceso sea interactivo.
			</p>

			<h3>INFORMACION RECOGIDA</h3>
			<p>
				Needex es una aplicación que genera recursos económicos a través del
				pago dentro de la aplicación, ya que se constituye como un servicio que
				ofrece servicios de terceros. Needex mostrara dentro de los paneles
				diseñados el nombre, del usuario, el nombre de la persona referida como
				experto, la ubicación del sitio donde el experto se encuentre para poder
				requerir los servicios del mismo, dirección que el usuario tenga que
				brindar para que el experto pueda llegar al destino requerido, todo en
				tiempo real. Posteriormente para los expertos existirá el método de
				puntaje por el que los usuarios podrán calificar el trabaja brindando
				información adicional a los usuarios en general, este método de puntaje
				será únicamente para este fin. La información como el nombre de la
				persona por ambos lados se podrá observar en la aplicación, la dirección
				de ambas partes igualmente se podrá observar dentro de la aplicación,
				ver en tiempo real el transcurso que el experto tenga realizar hasta
				llegar a su destino podrá verse también dentro de la aplicación. Todos
				estos datos simplemente se usarán para el proceso que se lleve a cabo
				por los expertos, información que será solo para localizar, contactar
				con el experto y el usuario final.
			</p>

			<p>
				La información que se disponga en principio es solo para mostrarla
				dentro de la aplicación, de ninguna manera Needex brindara de otras
				formas la información personal de las y los usuarios que lleguen a
				interactuar con esta misma. Siempre podrás ver en nuestra página web las
				políticas de privacidad que describimos aquí ya que, posteriormente
				podrás ver si actualizamos estas mismas, agregando, mejorando o
				cambiando partes de las mismas a través de la siguiente url:{" "}
			</p>

			<a href="https://needex-bo.web.app">www.needex-bo.web.app</a>
		</div>
	);
};

export default PoliciesExperts;
